import React from "react";
import RosePie from "charts/RosePie";

const data = [
  { name: "OPPO", value: 14213449821 },
  { name: "VIVO", value: 12566279800 },
  { name: "华为", value: 11022904466 },
  { name: "苹果", value: 10349791542 },
  { name: "小米", value: 3349251744 },
  { name: "魅族", value: 1334117255 },
  { name: "三星", value: 1203622625 },
  { name: "乐视", value: 407430933 },
  { name: "金立", value: 383903103 },
  { name: "中国移动", value: 23547259 },
];

const MobBrand: React.FC = () => {
  return <RosePie data={data} roseType="radius" ring />;
};

export default MobBrand;
